<div class="rich-text-editor-wrapper">
    <!-- Toolbar -->
    <div class="editor-toolbar">
      <div class="toolbar-group">
        <button mat-icon-button 
                matTooltip="Bold" 
                (click)="execCommand('bold')"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_bold</mat-icon>
        </button>
        <button mat-icon-button 
                matTooltip="Italic" 
                (click)="execCommand('italic')"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_italic</mat-icon>
        </button>
        <button mat-icon-button 
                matTooltip="Underline" 
                (click)="execCommand('underline')"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_underlined</mat-icon>
        </button>
        <button mat-icon-button 
                matTooltip="Strikethrough" 
                (click)="execCommand('strikeThrough')"
                [disabled]="disabled"
                type="button">
          <mat-icon>strikethrough_s</mat-icon>
        </button>
      </div>
  
      <div class="toolbar-divider"></div>
  
      <div class="toolbar-group">
        <button mat-icon-button 
                matTooltip="Align Left" 
                (click)="execCommand('justifyLeft')"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_align_left</mat-icon>
        </button>
        <button mat-icon-button 
                matTooltip="Align Center" 
                (click)="execCommand('justifyCenter')"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_align_center</mat-icon>
        </button>
        <button mat-icon-button 
                matTooltip="Align Right" 
                (click)="execCommand('justifyRight')"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_align_right</mat-icon>
        </button>
      </div>
  
      <div class="toolbar-divider"></div>
  
      <div class="toolbar-group">
        <button mat-icon-button 
                matTooltip="Bullet List" 
                (click)="insertList(false)"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_list_bulleted</mat-icon>
        </button>
        <button mat-icon-button 
                matTooltip="Numbered List" 
                (click)="insertList(true)"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_list_numbered</mat-icon>
        </button>
      </div>
  
      <div class="toolbar-divider"></div>
  
      <div class="toolbar-group">
        <button mat-icon-button 
                matTooltip="Insert Link" 
                (click)="insertLink()"
                [disabled]="disabled"
                type="button">
          <mat-icon>link</mat-icon>
        </button>
        <button mat-icon-button 
                matTooltip="Text Color" 
                (click)="changeTextColor()"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_color_text</mat-icon>
        </button>
        <button mat-icon-button 
                matTooltip="Background Color" 
                (click)="changeBackgroundColor()"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_color_fill</mat-icon>
        </button>
      </div>
  
      <div class="toolbar-divider"></div>
  
      <div class="toolbar-group">
        <button mat-icon-button
                matTooltip="Remove Formatting"
                (click)="execCommand('removeFormat')"
                [disabled]="disabled"
                type="button">
          <mat-icon>format_clear</mat-icon>
        </button>
      </div>

      <ng-container *ngIf="showAttachButton">
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <button mat-icon-button
                  matTooltip="Attach file"
                  (click)="attachFile.emit()"
                  [disabled]="disabled"
                  type="button">
            <mat-icon>attach_file</mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  
    <!-- Editor Content -->
    <div class="editor-container" [style.minHeight]="minHeight">
      <div #editor
           class="editor-content"
           contenteditable="true"
           [attr.contenteditable]="!disabled"
           [class.disabled]="disabled"
           [attr.data-placeholder]="placeholder"
           (input)="onInput($event)"
           (paste)="onPaste($event)"
           (keydown)="onKeyDown($event)"
           (blur)="onTouched()">
      </div>
  
      <!-- Mention Menu -->
      <div #mentionMenu
           class="mention-menu"
           *ngIf="showMentionMenu"
           [style.top.px]="mentionMenuPosition.top"
           [style.left.px]="mentionMenuPosition.left">
        <div class="mention-menu-header">
          <mat-icon>person</mat-icon>
          <span>Mention someone</span>
        </div>
        <div class="mention-menu-list">
          <div *ngFor="let user of filteredUsers; let i = index"
               class="mention-menu-item"
               [class.selected]="i === selectedUserIndex"
               (click)="selectUser(user, i)">
            <div class="user-avatar">
              <mat-icon>account_circle</mat-icon>
            </div>
            <div class="user-info">
              <div class="user-name">{{ user.firstName }} {{ user.lastName }}</div>
              <div class="user-email" *ngIf="user.email">{{ user.email }}</div>
            </div>
          </div>
        </div>
        <div class="mention-menu-footer">
          <small>Use ↑↓ to navigate, Enter to select, Esc to dismiss</small>
        </div>
      </div>
    </div>
  </div>